import { render, staticRenderFns } from "./activityEditExamRooms.html?vue&type=template&id=2bc68228&scoped=true&external"
import script from "./activityEditExamRooms.vue?vue&type=script&lang=js"
export * from "./activityEditExamRooms.vue?vue&type=script&lang=js"
import style0 from "./activityEditExamRooms.css?vue&type=style&index=0&id=2bc68228&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc68228",
  null
  
)

export default component.exports